import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react'
import { ChevronRight } from 'lucide-react'
import { useThemeColors } from '@/hooks/useThemeColors'

export type QuickLinkItem = {
  id: string
  label: string
  count?: number
  onClick: () => void
  alertDot?: boolean
}

type Props = {
  links: QuickLinkItem[]
}

export default function OverviewQuickLinks({ links }: Props) {
  const colors = useThemeColors()

  if (links.length === 0) return null

  return (
    <Box pt={2.5} borderTop="1px solid" borderColor={colors.borderLight}>
      <Text fontSize="11px" fontWeight="500" color={colors.textSecondary} mb={1.5}>
        Quick links
      </Text>
      <VStack align="stretch" spacing={1.5}>
        {links.map((link) => (
          <Button
            key={link.id}
            variant="outline"
            size="sm"
            justifyContent="space-between"
            fontWeight="normal"
            color={colors.text}
            onClick={link.onClick}
            w="100%"
          >
            <HStack flex="1" spacing={2} minW={0}>
              <Text as="span" flex="1" textAlign="left" fontSize="xs">
                {link.label}
                {link.count != null && link.count > 0 ? ` (${link.count})` : ''}
              </Text>
              {link.alertDot ? (
                <Box w="6px" h="6px" borderRadius="full" bg="red.500" flexShrink={0} aria-hidden />
              ) : null}
            </HStack>
            <ChevronRight size={14} />
          </Button>
        ))}
      </VStack>
    </Box>
  )
}
